import { render, staticRenderFns } from "./XEmbed.vue?vue&type=template&id=49e3ef62"
import script from "./XEmbed.vue?vue&type=script&lang=js"
export * from "./XEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports